import React from 'react';

const ProofOfMedicareAlert = (
  <va-alert status="info" class="vads-u-margin-bottom--3">
    Applicants that don’t have Medicare Parts A and B or proof of ineligibility
    may not be eligible for CHAMPVA.
  </va-alert>
);

export default ProofOfMedicareAlert;
